<template>
	<div class="MAM_queryList">
		<!-- 表单搜索部分 -->
		<el-card class="box-card" shadow="hover">
			<el-form :inline="true" :model="queryForm" class="demo-form-inline">
				<el-form-item>
					<el-select size v-model="queryForm.status" clearable placeholder="状态">
						<el-option label="启用" value="1"></el-option>
						<el-option label="停用" value="2"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-date-picker
					    v-model="rangeDate"
					    type="daterange"
					    range-separator="至"
					    start-placeholder="创建开始日期"
					    end-placeholder="创建结束日期"
					    value-format="yyyy-MM-dd"
					    @change="pickerChange"
					></el-date-picker>
				</el-form-item>
                <el-form-item>
                	<el-date-picker
                	    v-model="rangeDate2"
                	    type="daterange"
                	    range-separator="至"
                	    start-placeholder="更新开始日期"
                	    end-placeholder="更新结束日期"
                	    value-format="yyyy-MM-dd"
                	    @change="pickerChange2"
                	></el-date-picker>
                </el-form-item>
				<el-form-item>
					<el-button size="medium" type="primary" icon="el-icon-search" style="font-size: 12px;"
						@click="onSearch(queryForm)">查询</el-button>
					<el-button size="medium" type="primary" icon="el-icon-plus" style="font-size: 12px;"
						@click="addForm()">添加方案</el-button>
				</el-form-item>
			</el-form>
		</el-card>
		<!-- 表格部分 -->
		<el-card class="box-card" style="margin-top: 20px;" shadow="hover">

			<el-table :data="stockTable" size="mini" border style="width: 100%" v-loading="loading">
				<el-table-column header-align="center" align="center" fixed type="index" label="序号"
					min-width="80"></el-table-column>

				<el-table-column header-align="center" align="center" prop="net_day" label="入网天数"></el-table-column>
				<el-table-column min-width="150" header-align="center" align="center" prop="agent_no" label="单笔交易额(区间) ">
                    <template slot-scope="scope">
                    	<span>
                    		{{scope.row.min_money}} - {{scope.row.max_money}}
                    	</span>
                    </template>
                </el-table-column>
				<el-table-column header-align="center" align="center" prop="transaction_count" label="交易笔数≥"></el-table-column>
                <el-table-column header-align="center" align="center" prop="card_type_text" label="交易类型"></el-table-column>
                <el-table-column min-width="120" header-align="center" align="center" prop="is_filter_int_text" label="是否过滤整数"></el-table-column>
                <el-table-column min-width="120" header-align="center" align="center" prop="optimize_ratio" label="优化比例(%)"></el-table-column>
                <el-table-column min-width="120" header-align="center" align="center" prop="repeat_ratio" label="重合比例(%)"></el-table-column>
                <el-table-column min-width="160" header-align="center" align="center" prop="create_time" label="创建时间"></el-table-column>
                <el-table-column min-width="160" header-align="center" align="center" prop="update_time" label="更新时间"></el-table-column>
                <el-table-column min-width="120" header-align="center" align="center" prop="repeat_ratio" label="状态">
                    <template slot-scope="scope">
                    	<span v-if="scope.row.status == 1">
                    		启用
                    	</span>
                        <span v-if="scope.row.status == 2">
                        	停用
                        </span>
                    </template>
                </el-table-column>

				<el-table-column header-align="center" align="center" fixed="right" label="操作" width="150">
					<template slot-scope="scope">
						<el-button @click="handleInfo(scope.row)" type="text" size="small">编辑</el-button>
						<el-button @click="renew(scope.row,1)" type="text" size="small"
							v-if="scope.row.status == 2 " style="color: #67C23A">启用</el-button>
						<el-button @click="renew(scope.row,2)" type="text" size="small"
							v-if="scope.row.status == 1 " style="color: #F56C6C">停用</el-button>
						
					</template>
				</el-table-column>

			</el-table>
			<!-- 分页部分 -->
			<paginations :currentPage="page.currentPage" :pageSize="page.pageSize" :total="page.total"
				@watchCurrent="getCurrent" @watchPageSize="getPageSize"></paginations>
		</el-card>

		<el-dialog title="添加方案" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
			<el-form :model="policyForm" size="small" label-width="120px" :rules="policyFormRules" ref="policyForm">
				
				<el-row>
					<el-col :span="8">
						<el-form-item label="入网天数" prop="net_day">
							<el-input size clearable v-model="policyForm.net_day" placeholder="请输入入网天数"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="16" style="display: flex;justify-content: flex-start;align-items: center;">
                        <span style="margin-left:10px">天，且单笔交易额</span>
						<el-form-item label-width="20px"  prop="min_money">
							<el-input size clearable v-model="policyForm.min_money" style="width:100px !important;" min="0" @input="policyForm.min_money=policyForm.min_money.replace(/^(0+)|[^\d]+/g,'')">
								<template slot="suffix">元</template>
							</el-input>
						</el-form-item>
						<span style="width: 5px;margin-top: -5px;margin-left: 10px;">一</span>
						<el-form-item label-width="20px"  prop="max_money">
							<el-input size clearable v-model="policyForm.max_money" style="width:100px !important;"  min="0" @input="policyForm.max_money=policyForm.max_money.replace(/^(0+)|[^\d]+/g,'')">
								<template slot="suffix">元</template>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
                <el-row  style="margin-top: 20px;">
                	<el-col :span="10">
                		<el-form-item label-width="170px" label="且单日贷记卡交易笔数≥" prop="transaction_count">
                			<el-input size clearable v-model="policyForm.transaction_count" placeholder="请输入交易笔数"></el-input>
                		</el-form-item>
                	</el-col>
                    <el-col :span="10">
                    	<el-form-item label="交易类型" prop="card_typeArr" >
                    		<el-select multiple size v-model="policyForm.card_typeArr">
                    			<el-option label="借记卡" value="1"></el-option>
                    			<el-option label="贷记卡" value="2"></el-option>
                    		</el-select>
                    	</el-form-item>
                    </el-col>
                	
                </el-row>
                <el-row style="margin-top: 20px;">
                    <el-col :span="10">
                    	<el-form-item label="是否过滤整数交易额" prop="is_filter_int">
                    		<el-select size v-model="policyForm.is_filter_int">
                    			<el-option label="是" :value="1"></el-option>
                    			<el-option label="否" :value="0"></el-option>
                    		</el-select>
                    	</el-form-item>
                    </el-col>
                	<el-col :span="10">
                		<el-form-item label-width="100px" label="优化比例(%)" prop="optimize_ratio">
                			<el-input size clearable v-model="policyForm.optimize_ratio" placeholder="请输入优化比例"></el-input>
                		</el-form-item>
                	</el-col>
                </el-row>
                
                <el-row style="margin-top: 20px;">
                	<el-col :span="10">
                		<el-form-item label-width="100px" label="重合比例(%)" prop="repeat_ratio">
                			<el-input size clearable v-model="policyForm.repeat_ratio" placeholder="请输入重合比例"></el-input>
                		</el-form-item>
                	</el-col>
                    <el-col :span="10">
                    	<el-form-item label="状态" prop="status">
                    		<el-select size v-model="policyForm.status">
                    			<el-option label="启用" :value="1"></el-option>
                    			<el-option label="停用" :value="2"></el-option>
                    		</el-select>
                    	</el-form-item>
                    </el-col>
                </el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleClose()">取 消</el-button>
				<el-button type="primary" @click="submitForm('policyForm')">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import paginations from '../../components/pagination/paginations';
	export default {
		name: "teamLeaderManagementList",
		data() {
			return {
				queryForm: {
					type: '1',
                    status:'',
                    page: 1, //当前页码
                    limit: 10, //条数
				},
				stockTable: [],
				page: {
					currentPage: 1, //当前页码
					pageSize: 10, //条数
					total: 100 //总数
				},
				loading: true,
				is_userteam: null,

				dialogVisible: false,
				policyForm: {
					id: '',
					net_day: '',
					min_money: '',
					max_money: '',
					transaction_count: '',
					card_type: '',
                    card_typeArr: [],
					is_filter_int: 1,
					optimize_ratio: '',
					repeat_ratio: '',
                    status: 1
				},
				policyFormRules: {
					net_day: [{
						required: true,
						message: '请输入入网天天数',
						trigger: 'blur'
					}],
                    min_money: [{
                    	required: true,
                    	message: '请输入单笔交易区间起始金额',
                    	trigger: 'blur'
                    }],
                    max_money: [{
                    	required: true,
                    	message: '请输入单笔交易区间结束金额',
                    	trigger: 'blur'
                    }],
                    transaction_count: [{
                    	required: true,
                    	message: '请输入交易笔数',
                    	trigger: 'blur'
                    }],
                    card_typeArr: [{
                    	required: true,
                    	message: '请选择交易类型',
                    	trigger: 'change'
                    }],
                    optimize_ratio: [{
                    	required: true,
                    	message: '请输入优化比例',
                    	trigger: 'blur'
                    }],
                    repeat_ratio: [{
                    	required: true,
                    	message: '请输入重合比例',
                    	trigger: 'blur'
                    }],

				},
                rangeDate2:[],
                rangeDate:[]
                
			}
		},
		mounted() {
			this.getData({
				page: this.page.currentPage,
				limit: this.page.pageSize,
                type:'1'
			})
		},
		components: {
			paginations,
		},
		methods: {
            pickerChange(DateArr) { //时间选择器
                this.queryForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
                this.queryForm.end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
            },
            pickerChange2(DateArr) { //时间选择器
                this.queryForm.start_update_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
                this.queryForm.end_update_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
            },
            //保存添加政策
            submitForm(formName) {
            	this.$refs[formName].validate((valid) => {
            		if (valid) {
                        this.policyForm.card_type = this.policyForm.card_typeArr.join(',')
                        this.policyForm.type = '1'
                        this.loading = true;
            			this.$api.post('gray_list/grayPlanSave', this.policyForm, res => {
                            this.loading = false;
            				if (res.code == 0) {
            					this.$message({
            						type: 'success',
            						message: res.msg,
            						duration: 2000,
            					})
            					this.getData(this.queryForm);
            					this.handleClose()
            				} else {
            					this.$message.error(res.msg);
            				}
            			})
            
            		} else {
            			console.log('error submit!!');
            			return false;
            		}
            	});
            },
            
            handleInfo(row) {
                this.policyForm  = row
                this.policyForm.card_typeArr = this.policyForm.card_type.split(',')
                this.dialogVisible = true;
            },
            //停用
            renew(row,val) {
            	let text = val == 1?'确定启用?':'确定停用';
            	this.$confirm(text, '提 示', {
            		type: 'warning',
            		distinguishCancelAndClose: true,
            		confirmButtonText: '确 定',
            		cancelButtonText: '取 消'
            	}).then(() => {
            		let data = {
            			id: row.id,
            			status: val,
            		};
            		this.loading = true; //防重复
            		this.$api.post('gray_list/grayPlanEditStatus', data, res => {
            			if (res.code == 0) {
            				this.$message({
            					type: 'success',
            					message: res.msg,
            					duration: 2000,
            				})
            				this.getData(this.queryForm);
            				this.loading = false;
            			} else {
            				this.$message.error(res.msg);
            				this.loading = false;
            			}
            		})
            	}).catch(() => {
            
            	})
            },

			
			//关闭弹框
			handleClose() {
                this.policyForm = {
                	id: '',
                	net_day: '',
                	min_money: '',
                	max_money: '',
                	transaction_count: '',
                	card_type: '',
                	is_filter_int: '1',
                	optimize_ratio: '',
                	repeat_ratio: '',
                    status: '1',
                }
				this.dialogVisible = false;
			},
			//打开弹框
			addForm() {
                this.policyForm = {
                	id: '',
                	net_day: '',
                	min_money: '',
                	max_money: '',
                	transaction_count: '',
                	card_type: '',
                	is_filter_int: 1,
                	optimize_ratio: '',
                	repeat_ratio: '',
                    status: 1,
                }
				this.dialogVisible = true;
			},

			onSearch(queryForm) {
				this.page.currentPage = 1;
				queryForm.page = this.page.currentPage;
				queryForm.limit = this.page.pageSize;
				queryForm.is_list = 2
				// 表单提交
				this.getData(queryForm);
			},

			//分页
			getCurrent(page) {
				// 获取当前页修改的值
				this.page.currentPage = page;
				this.loading = true;
				this.queryForm.page = page;
				this.queryForm.limit = this.page.pageSize;
				this.getData(this.queryForm);
			},
			getPageSize(limit) {
				this.page.currentPage = 1;
				// 获取条数发生改变的值
				this.page.pageSize = limit;
				this.loading = true;
				this.queryForm.page = this.page.currentPage;
				this.queryForm.limit = limit;
				this.getData(this.queryForm);
			},
			getData(params) {
				this.loading = true;
				this.$api.post("gray_list/grayPlanList", params, res => {
					let data = res.data;
					if(data.length != 0){
						this.page.total = data.count; //总数
						this.stockTable = data.list;
					}else{
						this.page.total = 0; //总数
						this.stockTable = [];
					}
					// //渲染结束后取消加载
					this.loading = false;
				})
			}
		}
	};
</script>

<style lang="scss" scope>
	.MAM_queryList {
		.el-input__inner {
			font-size: 12px;
		}

		.el-form-item {
			margin-bottom: 5px;
		}
	}
</style>